import { tr as __tr, useLocale as __useLocale, direction as __direction, localizedField as __localizedField } from "../i18n/runtime";
import React, { useState, useEffect } from 'react';
import { Hotel, Bus, FileText, Plane } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import BusBookingForm from './forms/BusBookingForm';
import HotelBookingForm from './forms/HotelBookingForm';
import VisaBookingForm from './forms/VisaBookingForm';
import FlightBookingForm from './forms/FlightBookingForm';
const BookingTabs = () => {
  __useLocale();
  const [activeTab, setActiveTab] = useState('hotels');
  useEffect(() => {
    const sync = () => {
      const tab = window.location.hash.slice(1);
      if (['hotels', 'visas', 'buses', 'flights'].includes(tab)) {
        setActiveTab(tab);
        document.getElementById('booking-search')?.scrollIntoView({
          behavior: 'smooth'
        });
      }
    };
    sync();
    window.addEventListener('hashchange', sync);
    return () => window.removeEventListener('hashchange', sync);
  }, []);
  const tabs = [{
    id: 'flights',
    name: "الطيران",
    icon: Plane,
    soon: false
  }, {
    id: 'visas',
    name: "التأشيرات",
    icon: FileText,
    soon: false
  }, {
    id: 'buses',
    name: "الحافلات",
    icon: Bus,
    soon: false
  }, {
    id: 'hotels',
    name: "الفنادق",
    icon: Hotel,
    soon: false
  }];
  return <div id="booking-search" className="relative -mt-16 z-20 px-4 scroll-mt-20">
      <div className="max-w-5xl mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Advanced search link */}
          <div className="text-center py-3 border-b bg-gray-50">
            <button onClick={() => document.querySelector('#booking-search select')?.focus()} className="text-[#6B5B95] hover:text-[#5B4B85] text-sm font-medium transition-colors">{__tr(" بحث متقدم ")}</button>
          </div>

          <Tabs value={activeTab} onValueChange={value => {
          setActiveTab(value);
          window.history.replaceState(null, '', `#${value}`);
        }} className="w-full" dir={__direction()}>
            {/* Tab Headers */}
            <TabsList className="w-full bg-white border-b rounded-none h-auto p-0 justify-end">
              {__tr(tabs.map(tab => <TabsTrigger key={tab.id} value={tab.id} disabled={tab.soon} className={`relative flex items-center gap-2 px-6 py-4 text-sm font-medium rounded-none border-b-2 border-transparent data-[state=active]:border-[#6B5B95] data-[state=active]:text-[#6B5B95] data-[state=active]:bg-purple-50/50 transition-all duration-300 ${tab.soon ? 'opacity-60' : ''}`}>
                  <tab.icon className="w-5 h-5" />
                  <span>{__tr(__localizedField(tab, "name"))}</span>
                  {__tr(tab.soon && <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] px-2 py-0.5 rounded-full font-bold">
                      SOON
                    </span>)}
                </TabsTrigger>))}
            </TabsList>

            {/* Tab Contents */}
            <TabsContent value="hotels" className="p-6 mt-0">
              <HotelBookingForm />
            </TabsContent>

            <TabsContent value="buses" className="p-6 mt-0">
              <BusBookingForm />
            </TabsContent>

            <TabsContent value="visas" className="p-6 mt-0">
              <VisaBookingForm />
            </TabsContent>

            <TabsContent value="flights" className="p-6 mt-0">
              <FlightBookingForm />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </div>;
};
export default BookingTabs;
